export enum FileState {
  uploading = 'uploading',
  uploaded = 'uploaded',
  failed = 'failed'
}
